/* eslint-disable */
/* Code generated by generate-angular-formgroups.mjs DO NOT EDIT. */
import { signal, WritableSignal } from '@angular/core';
import { form, required, SchemaPathTree } from '@angular/forms/signals';
import { LexplusRequestPasswordResetDto } from '../models';

/** Initial value for the signal model. */
export function getLexplusRequestPasswordResetDtoInitialValue(): LexplusRequestPasswordResetDto {
  return {
  email: '',
} as LexplusRequestPasswordResetDto;
}

/**
 * Reusable Signal Forms schema for LexplusRequestPasswordResetDto.
 * Can be passed to form() directly or embedded via apply()/applyEach().
 */
export function lexplusRequestPasswordResetDtoSchema(path: SchemaPathTree<LexplusRequestPasswordResetDto>): void {
  required(path.email);
}

/**
 * Creates the model signal and the form in one call.
 * The model signal is needed for submit(), for example: submit(field, { action }).
 */
export function createLexplusRequestPasswordResetDtoForm(initial?: Partial<LexplusRequestPasswordResetDto>) {
  const model: WritableSignal<LexplusRequestPasswordResetDto> = signal<LexplusRequestPasswordResetDto>({
    ...getLexplusRequestPasswordResetDtoInitialValue(),
    ...initial,
  } as LexplusRequestPasswordResetDto);
  return { model, field: form(model, lexplusRequestPasswordResetDtoSchema) };
}
